import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'immutable-prop-types';
import SelectComponent from 'pu-react/components/SelectComponent';

const railWidthOptions = [
  {
    value: '',
    text: 'Select One',
  },
  {
    value: '0.250',
    text: '0.250"',
  },
  {
    value: '0.400',
    text: '0.400"',
  },
  {
    value: '0.500',
    text: '0.500"',
  },
];


class RailsWidth extends React.Component {
  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, snapshot) {
    // dont show 'required field error' when the form is validated and the customer select no-rails
    if (jQuery('label.error:visible').length && this.props.parameters.rails_sides) {
      vfIsValidForQuote('#quote_form', false);
    }
  }

  render() {
    const disabled = this.props.parameters.rails_sides === 'no_sides';
    return (
      <SelectComponent
        label={this.props.label}
        name={this.props.name}
        onChange={e => this.props.onChangeParameter(this.props.name, e.target.value)}
        options={this.props.options}
        selected={this.props.parameters[this.props.name]}
        groupName={this.props.groupName}
        disabled={disabled} />
    );
  }
}

RailsWidth.defaultProps = {
  label: 'Rail Width',
  options: railWidthOptions,
  groupName: 'parameters',
  name: 'rail_width',
};

// RailsWidth.propTypes = {
//   label            : PropTypes.string,
//   groupName        : PropTypes.string,
//   name             : PropTypes.string,
//   onChangeParameter: PropTypes.func.isRequired,
//   parameters       : ImmutablePropTypes.map.isRequired,
//   options          : PropTypes.arrayOf(PropTypes.object),
// };

export default RailsWidth;
